import React, { useEffect } from "react";
import { Card, Col, Image, Result, Row } from "antd";
import { useTranslation } from "react-i18next";
import Mobile_logo_ar from "../../../assets/imgs/thrivve-logo-ar.svg";
import { useAppDispatch, useAppSelector } from "../../../shared/hooks/redux";
import { resetPhoneConfirmationState } from "../phone-confirmation.slice";

function ResultStep() {
    const { resultMsg } = useAppSelector(({ PhoneConfirmation }) => PhoneConfirmation);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();

    useEffect(() => {
        dispatch(resetPhoneConfirmationState());
    }, [dispatch]);
    return (
        <Card
            title={
                <Row align={"middle"} justify={"center"}>
                    <Col>
                        <Image src={Mobile_logo_ar} alt="thrivve logo" preview={false} />
                    </Col>
                </Row>
            }
            className="resultCard"
        >
            <Result
                status={"success"}
                title={t(resultMsg)}
            />
        </Card>
    );
}
export default ResultStep;